import { useState } from 'react';
import { Customer } from 'models';
import DevicePayButton from 'components/DevicePayButton/DevicePayButton';
import CopyToClipboard from 'components/CopyToClipboard';
import QRModal from 'views/modals/QRModal';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { Wrapper, Subtitle, Text, StyledQRButton } from './ProfileCard.styles';
import content from './ProfileCard.content.json';

export interface ProfileCardProps {
  user: Customer;
  className?: string;
}

const ProfileCard = ({ user, className }: ProfileCardProps) => {
  const [displayQRCode, setDisplayQRCode] = useState(false);

  const { label, text } = content;
  const {
    personalDetails: { memberId },
  } = user;

  const userID = `Zillionaire ID: ${memberId}`;
  const description = `Show your Zillionaire ID to your server to register your visit and bank those Zs.`;

  const handleClick = () => {
    setDisplayQRCode(!displayQRCode);
  };

  const handleOnCopy = () => {
    pushAnalyticsEvent({ event: 'userCopyID', location: 'Home Page' });
  };

  return (
    <>
      <Wrapper className={className}>
        <StyledQRButton onClick={handleClick} />
        <Text variant="h6">{label}</Text>
        <Subtitle variant="h4">
          {memberId} <CopyToClipboard value={memberId} onCopy={handleOnCopy} />
        </Subtitle>
        <QRModal
          title={userID}
          isOpen={displayQRCode}
          description={description}
          onClose={handleClick}
          code={memberId}
        />
        <Text variant="body2">{text}</Text>
        <DevicePayButton user={user} />
      </Wrapper>
    </>
  );
};

export default ProfileCard;
